import { createStyles, makeStyles } from "@material-ui/core";
import { DefaultStyles } from "./styles";

export const useStyles = makeStyles(() =>
    createStyles({
        ...DefaultStyles,
    }),
);
